// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 764) return "static/chunks/764-26b0b2bf533f9b32.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"13":"1a095298c63da289","369":"fcd2b35cb0cf7b86","920":"e4cf6abbf508601d","970":"6dc88b020d9d2b25"}[chunkId] + ".js";
};